import React from 'react'
import {
  BooleanField,
  ImageField,
  Item,
  TextField,
} from '../../../types/SitecoreAdapter'
import { Image } from '@sitecore-jss/sitecore-jss-react'

// Footer Column Adapter
export type FooterColumnProps = Item<{
  columns: Item<{
    heading: TextField
    headingLink: TextField
    items: Item<{
      href: TextField
      text: TextField
      image: ImageField
      title: TextField
      newWindow: BooleanField
    }>[]
    isSocial: BooleanField
  }>[]
}>

export const columnAdapter = ({ fields: { columns } }: FooterColumnProps) => {
  return columns.map(
    ({ fields: { heading, headingLink, items, isSocial } }) => {
      return {
        type: isSocial.value ? 'social' : 'link',
        heading: {
          text: heading.value,
          href: headingLink.value,
          title: heading.value,
        },
        items: items.map(
          ({ fields: { href, text, image, title, newWindow } }) => {
            return {
              text: text && text.value,
              href: href && href.value,
              title: title && title.value,
              newWindow: (newWindow && newWindow.value) || false,
              image: image && <Image field={image} loading="lazy" />,
            }
          }
        ),
      }
    }
  )
}
